import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			rootHeader: {
				display: "flex",
				height: 50,
				alignItems: "center",
				justifyContent: "center"
			},
			titleHeader: {
				fontWeight: 600,
				fontSize: 18
			},
			btnClose: {
				position: "absolute",
				right: 0
			},
			root: {
				background: theme.palette.common.white
			},
			title: {
				color: theme.palette.primary.contrastText,
				fontSize: 20,
				fontWeight: 500,
				marginBottom: 20
			},
			text: {
				color: theme.palette.primary.contrastText,
				fontSize: 14
			},
			textTime: {
				color: theme.palette.grey[700],
				fontSize: 12,
				margin: "10px 0px"
			}
		}),
	{
		name: "NewsPage",
		index: 1
	}
);

export default useStyles;
